module.exports = __webpack_public_path__ + "flatfair_white_with_white_house.793ed1e1841bd181ed7bc91830b212ec.png";